import { IoWarningOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import { deleteAccountAsync } from "../../../services/accountService";
import Toaster from "../../../components/common/Toaster";

const DeleteForm = ({ data, isLoading, setLoading, onClose }) => {
  const handleDelete = async () => {
    try {
      setLoading(true);

      await deleteAccountAsync(data.id);

      Toaster.Success("Account Deleted Successfully");
      window.location = "/accounts";
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <div className="flex justify-center">
        <div>
          <div className="flex justify-center">
            <IoWarningOutline className="text-red-500 text-4xl" />
          </div>
          <p className="text-gray-400 text-sm mt-5">
            Are you sure you want to delete this account?
          </p>
        </div>
      </div>
      <div className="grid grid-cols-3 mt-12 space-x-2">
        <div className="col-span-1">
          <button
            className="text-gray-400 text-sm button float-right hover:text-blue-400"
            onClick={() => onClose()}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-2">
          <button
            className="button bg-red-500 text-white disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
            onClick={() => handleDelete()}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            Yes, delete it.
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteForm;
